class SearchDrawer extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.panel = this.querySelector('[role="dialog"]');
    this.detailModal = this.querySelector('.detail-modal');
    this.input = this.querySelector('[data-search-drawer-input]');
    this.closeButtons = Array.from(this.querySelectorAll('[data-search-drawer-close]'));
    this.openButtons = Array.from(document.querySelectorAll('[data-search-drawer-open]')).filter(
      (button) => button.dataset.searchDrawerTarget === this.id,
    );
    this.onKeydown = this.onKeydown.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.openButtons.forEach((button) => button.addEventListener('click', this.open));
    this.closeButtons.forEach((button) => button.addEventListener('click', this.close));
    this.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.openButtons?.forEach((button) => button.removeEventListener('click', this.open));
    this.closeButtons?.forEach((button) => button.removeEventListener('click', this.close));
    this.removeEventListener('keydown', this.onKeydown);
    if (this.hasAttribute('open')) document.body.classList.remove('ta-search-drawer-open');
    this.initialized = false;
  }

  getFocusableElements() {
    return Array.from(
      this.panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    ).filter((element) => !element.hidden && element.getClientRects().length > 0);
  }

  open(event) {
    this.opener = event.currentTarget;
    this.setAttribute('open', '');
    this.detailModal?.classList.add('active');
    this.panel.setAttribute('aria-hidden', 'false');
    this.openButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
    document.body.classList.add('ta-search-drawer-open');
    // This must remain inside the activation handler. Deferring to a frame can
    // make iOS Safari treat it as an untrusted focus and suppress its keyboard.
    if (this.input) this.input.focus({ preventScroll: true });
  }

  close() {
    if (!this.hasAttribute('open')) return;
    this.removeAttribute('open');
    this.detailModal?.classList.remove('active');
    this.panel.setAttribute('aria-hidden', 'true');
    this.openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('ta-search-drawer-open');
    const predictiveSearch = this.querySelector('predictive-search');
    if (predictiveSearch && typeof predictiveSearch.close === 'function') predictiveSearch.close(true);
    if (this.opener?.isConnected) this.opener.focus();
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = this.getFocusableElements();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

if (!customElements.get('search-drawer')) customElements.define('search-drawer', SearchDrawer);
